







import { Vue, Component } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import Overlay from '../Overlay.vue'
import PayPal from './PayPal.vue'
import Spinner from '../BaseSpinner.vue'
import StripePay from './StripePay.vue'

const cart = namespace('cart')
const intlShippingErrorMessage = 'Due to pandemic we are seeing significant international delays. We are limiting international shipping for the time being. We apologize for any inconvenience.'

@Component({ components: { StripePay, Overlay, PayPal, Spinner } })
export default class ExpressCheckout extends Vue {

  paypalEnabled: boolean

  data() {
    return { paypalEnabled: false }
  }

  async enablePayPal () {
    this.paypalEnabled = true
  }

}
